import { QueryFeature } from '../../../config/queryClient';
import { OnboardingWorkflow } from '../../CommonSelectors/CommonArea.types';

enum QueryKey {
  ClientAccess = 'ClientAccess',
  ModelPortfolioGroups = 'ModelPortfolioGroups',
  ClientSettings = 'ClientSettings',
}

export const queryKeys = {
  clientAccess: (clientId: string, defaultOnboardingWorkflow?: OnboardingWorkflow) => [
    QueryFeature.ClientAccess,
    QueryKey.ClientAccess,
    clientId,
    defaultOnboardingWorkflow,
  ],

  modelPortfolioGroups: () => [QueryFeature.ClientAccess, QueryKey.ModelPortfolioGroups],

  clientSettings: (clientId: string) => [
    QueryFeature.ClientAccess,
    QueryKey.ClientSettings,
    clientId,
  ],
};
